module.exports = __webpack_public_path__ + "static/media/kuchapecha.7a0f133c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/kuchapecha.jpg
// module id = 507
// module chunks = 0